import Vue from 'vue'
import Router from 'vue-router'
import CitySelect from './views/CitySelect.vue'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'root',
            component: CitySelect,
            meta: {
                layout: "selectCities",

            }
        },
        {
            path: "*",
            redirect: {name: 'root'}

        }

    ]
})



router.onError(() => {
    //TODO catch errore rotte
    console.log("errore")

})

export default router